<template>
	<div id="wrapper">
		<SidebarView :reports="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="container">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="row align-items-center">
								<div class="col-6">
									<h6 class="m-0 fw-bold text-green">
										Voucher Reports
									</h6>
								</div>
								<div class="col-6 text-end">
									<b-button @click="generateExcel"
										class="btn-sm ms-5 me-2 akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'file-excel']" />
									</b-button>
									<report-filter :form="form" @filterAction="filterAction"
										:filter="filter"></report-filter>
									<b-button @click="printPDF"
										class="me-2 btn-sm akkurate-green-btn akkurate-small"><font-awesome-icon
											:icon="['fas', 'print']" /></b-button>
									<b-button @click="downloadPDF"
										class="btn-sm akkurate-green-btn akkurate-small"><font-awesome-icon
											:icon="['fas', 'download']" /></b-button>
								</div>
							</div>
						</div>
						<div class="card-body" ref="pdfContent">
							<div class="row">
								<div class="col-12 col-md-12">
									<statement-institution :institution="institution" :current_date="false"
										:title="'VOUCHER REPORT'"></statement-institution>
								</div>
								<hr />
								<div class="row mb-2">
									<div class="col-12 small">
										Branch(es) : {{ branch_list_display }}
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-8"></div>
								<div class="col-md-4 text-end">
									<span style="font-weight: bold" v-if="form.start_date && form.end_date">From {{
										form.start_date }} to
										{{ form.end_date }}</span>
								</div>
							</div>
							<div v-if="isBusy" class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>Loading...</strong>
							</div>
							<div class="row">
								<div class="col-12 col-md-12 trans_details">
									<b-table striped bordered responsive="lg" id="voucher-table" :busy.sync="isBusy"
										:items="rows.map((row) => {
											return {
												...row,
												amount_requested:
													displayNumber(
														row.amount_requested
													),
												amount_approved:
													displayNumber(
														row.amount_approved
													),
											};
										})
											" :fields="fields" :tbody-tr-class="rowClass" show-empty>
										<template #table-busy>
											<div class="text-center text-danger my-2">
												<b-spinner class="align-middle"></b-spinner>
												<strong>Loading...</strong>
											</div>
										</template>
									</b-table>
								</div>
								<div class="col-md-12 trans_details">
									<div class="d-flex justify-content-between">
										<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
											:total-rows="totalRecords" :per-page="perPage"
											aria-controls="member-table"></b-pagination>
										<div class="col text-end mt-1 akkurate-dark">
											<div>
												{{ currentPage }} -
												{{ perPage }} of
												{{ totalRecords }}
											</div>
											<b-form-group label="Per Page" label-size="sm" class="mb-0">
												<b-form-select @change="selectPerPage" id="per-page-select"
													v-model="perPage" :options="per_page_options"
													size="sm"></b-form-select>
											</b-form-group>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import html2pdf from "html2pdf.js";
import ReportFilter from "@/views/main/pages/reports/form/ReportFilter.vue";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		StatementInstitution,
		Multiselect,
		ReportFilter,
		ChatBot,
	},
	data() {
		return {
			totalRecords: 0,
			filter: {
				branches: true,
				products: false,
				users: false,
				status: false,
				condition: false,
				coa: false,
				terms: false,
				start_date: true,
				end_date: true,
			},
			form: {
				start_date: this.getOneMonthEailer(),
				end_date: new Date().toISOString().split("T")[0],
				branches: [],
				products: [],
				branch_options: [],
				product_options: [],
				users: [],
				users_options: [],
				status: [],
				coa: [],
				coa_options: [],
				terms: "YTD",
				terms_options: ["YTD", "Periodic"],
				categories: [],
			},
			branch_list: "",
			branch_arr: [],
			status_arr: [],
			search: "Search",
			isBusy: false,
			currentPage: 1,
			isBusy: false,
			isSearching: false,
			isLoadingInstitution: false,
			institution: "",
			fields: [
				{
					key: "code",
					label: "Code",
				},
				{
					key: "beneficiary_name",
					label: "Beneficiary",
				},
				{
					key: "beneficiary_phone",
					label: "Phone",
				},
				{
					key: "cheque_number",
					label: "Cheque",
				},
				{
					key: "narration",
					label: "Narration",
				},
				{
					key: "amount_requested",
					label: "Req amount",
				},
				{
					key: "recorded_date",
					label: "Trans date",
				},

				{
					key: "amount_approved",
					label: "Approved amount",
				},
				{
					key: "branch.name",
					label: "Branch",
				},
				{
					key: "status",
					label: "Status",
				},
			],
			rows: [],
			per_page_options: ["10", "20", "50", "100", "500"],
			currentPage: 1,
			perPage: 10,
			totalRecords: 0,
		};
	},
	computed: {
		sumLoanBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total = this.items[i].loan_balance;
			}
			return total;
		},
		sumSavingBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total = this.items[i].saving_balance;
			}

			return total;
		},
		branch_list_display() {
			const selected = this.form.branches || [];
			const all = this.form.branch_options || [];

			if (selected.length > 0) {
				return selected.map(b => b.name).join(", ");
			}
			if (all.length > 0) {
				return all.map(b => b?.name).join(", ");
			}
			return "";
		}
	},

	created() {
		this.getInstitution();
		this.loadItems();
		this.getProductDropdown();
	},
	methods: {
		rowClass() {
			return "custom-row-height";
		},
		navigatePage(index) {
			this.isLoading = true;
			this.currentPage = index;
			this.loadItems();
		},
		selectPerPage(index) {
			this.perPage = index;
			this.loadItems();
		},
		filterTable() {
			this.loadItems();
		},

		navigatePage(index) {
			this.isBusy = true;
			this.currentPage = index;
			this.loadItems();
		},
		selectPerPage(index) {
			this.perPage = index;
			this.loadItems();
		},
		async getProductDropdown() {
			this.isBusy = true;
			this.search = "Processing...";
			await ApiService.query("/reports/controls/products/dropdown")
				.then((response) => {
					// console.log(response.data);
					this.isBusy = false;
					this.search = "Search";
					// console.log(response.data.branches)
					this.form.branch_options = response.data.branches;
					// this.form.product_options = response.data.products;
					// this.form.coa_options = response.data.coa_subheads;
				})
				.catch((error) => {
					// console.log(error);
					this.isBusy = false;
					this.search = "Search";
				});
		},
		async loadItems() {
			// this.items = [];
			let branches = [];
			//Reduce Branch Array Object For Filters
			branches = this.form.branches?.reduce(
				(accumulator, currentValue) => {
					accumulator.push(currentValue.id);
					return accumulator;
				},
				[]
			);
			this.isBusy = true;
			this.search = "Processing...";
			this.isSearching = true;
			await ApiService.post("/vouchers/paginate", {
				page: this.currentPage,
				per_page: this.perPage,
				filter: this.form.search,
				branch_ids: branches, //Eg. 1, 2, etc
				statuses: this.form.status,
				start_date: this.form.start_date,
				end_date: this.form.end_date,
				// "users_ids": users,
			})
				.then((response) => {
					// console.log(response);
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					// var res = response.data?.data;
					// this.branch_list = this.form.branches.map(branch => branch.name).join(", ");
					// res.map((index) => {
					//   const data = {
					//     code: index.code,
					//     beneficiary_name: index.beneficiary_name,
					//     beneficiary_phone: index.beneficiary_phone,
					//     cheque_number: index.cheque_number,
					//     amount_requested: index.amount_requested,
					//     amount_approved: index.amount_approved,
					//     status: index.status,
					//     branch: index.branch.name,

					//   }
					//   this.items.push(data);
					this.totalRecords = response.data.meta.total;
					this.rows = response.data.data; // Return data to populate the table
				})
				.catch((error) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					console.log(error);
				});
		},
		downloadPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
				})
				.save();
		},
		printPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
					// Get the blob of the PDF
					return pdf.output("blob");
				})
				.then((pdfBlob) => {
					// Create a URL for the PDF blob
					var pdfUrl = URL.createObjectURL(pdfBlob);

					// Open the URL in a new tab
					const printWindow = window.open(
						pdfUrl,
						"_blank",
						"width=800,height=600"
					);
					printWindow.onload = () => {
						printWindow.print();
						URL.revokeObjectURL(pdfUrl);
					};
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				});
		},

		async getInstitution() {
			this.isLoadingInstitution = true;
			await ApiService.get("/settings/institution")
				.then((response) => {
					this.institution = response.data.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					this.isLoadingInstitution = false;
				});
		},
		async generateExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx";
			const imageUrl = "/default_logo.png";

			const institutionName = this.institution.name || '';
			const institutionMotto = this.institution.motto || '';
			const institutionAddress = this.institution.address || '';
			const institutionPhone = this.institution.telephone || '';
			const institutionEmail = this.institution.email || '';
			const dateRange = `FROM: ${this.form.start_date} TO: ${this.form.end_date}`;

			try {
				// Load the Excel template
				const response = await fetch(fileUrl);
				if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);
				const arrayBuffer = await response.arrayBuffer();

				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);
				const ws = wb.getWorksheet(1);

				// Add institution logo if available
				try {
					const imageResponse = await fetch(imageUrl);
					if (imageResponse.ok) {
						const imageBuffer = await imageResponse.arrayBuffer();
						const imageId = wb.addImage({ buffer: imageBuffer, extension: "png" });
						ws.addImage(imageId, { tl: { col: 0, row: 0 }, ext: { width: 300, height: 200 } });
					}
				} catch (imageError) {
					console.warn("Could not load image:", imageError);
				}

				// Add institution details
				const startRow = 1;
				ws.getCell(`L${startRow}`).value = institutionName;
				ws.getCell(`L${startRow}`).font = { bold: true, size: 14 };
				ws.getCell(`L${startRow + 1}`).value = institutionAddress;
				ws.getCell(`L${startRow + 1}`).font = { size: 12 };
				ws.getCell(`L${startRow + 2}`).value = institutionMotto;
				ws.getCell(`L${startRow + 2}`).font = { size: 12 };
				ws.getCell(`L${startRow + 3}`).value = institutionPhone;
				ws.getCell(`L${startRow + 3}`).font = { size: 12 };
				ws.getCell(`L${startRow + 4}`).value = institutionEmail;
				ws.getCell(`L${startRow + 4}`).font = { size: 12 };
				ws.getCell(`L${startRow + 6}`).value = dateRange;
				ws.getCell(`L${startRow + 6}`).font = { size: 12 };
				ws.getCell(`L${startRow + 7}`).value = "Branch(es): " + this.branch_list_display;
				ws.getCell(`L${startRow + 7}`).font = { size: 12 };
				ws.getColumn("L").width = 50;

				// Add headers for the voucher table
				const headerRowNum = 13;
				const headerRow = ws.getRow(headerRowNum);
				headerRow.values = [
					"Code",
					"Beneficiary",
					"Phone",
					"Cheque",
					"Narration",
					"Req Amount",
					"Trans Date",
					"Approved Amount",
					"Branch",
					"Status"
				];
				headerRow.font = { bold: true };
				headerRow.alignment = { horizontal: "center" };
				headerRow.commit();

				let currentRowNum = headerRowNum + 1;

				// Loop through voucher items and add rows
				for (const item of this.rows) {
					const row = ws.getRow(currentRowNum);
					row.getCell(1).value = item.code || '';
					row.getCell(2).value = item.beneficiary_name || '';
					row.getCell(3).value = item.beneficiary_phone || '';
					row.getCell(4).value = item.cheque_number || '';
					row.getCell(5).value = item.narration || '';
					row.getCell(6).value = Number(item.amount_requested || 0);
					row.getCell(7).value = item.recorded_date || '';
					row.getCell(8).value = Number(item.amount_approved || 0);
					row.getCell(9).value = item.branch?.name || '';
					row.getCell(10).value = item.status || '';
					row.commit();
					currentRowNum++;
				}

				// Set column widths for better readability
				ws.getColumn(1).width = 15;  // Code
				ws.getColumn(2).width = 20;  // Beneficiary
				ws.getColumn(3).width = 15;  // Phone
				ws.getColumn(4).width = 15;  // Cheque
				ws.getColumn(5).width = 25;  // Narration
				ws.getColumn(6).width = 15;  // Req Amount
				ws.getColumn(7).width = 15;  // Trans Date
				ws.getColumn(8).width = 15;  // Approved Amount
				ws.getColumn(9).width = 20;  // Branch
				ws.getColumn(10).width = 15; // Status

				// Generate and download Excel file
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = `Voucher_Report_${this.form.start_date}_to_${this.form.end_date}.xlsx`;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(link.href);

			} catch (err) {
				console.error("Error generating Excel file:", err);
				this.$bvToast.toast('Failed to generate Excel file. Please try again.', {
					title: 'Export Error',
					variant: 'danger',
					solid: true
				});
			}
		},
	},
};
</script>
